import { Row, Col, Card } from 'react-bootstrap'
import SmashSpinner from '../../../../components/SmashSpinner/SmashSpinner';
import { usePlanForSummary } from '../../hook/usePlan';
import SmashStripe from '../../../../components/SmashStripe/SmashStripe';
import SmashPrice from '../../../../components/SmashPrice/SmashPrice';

const PlanSummary = () => {
    const [isLoading, plan] = usePlanForSummary();

    return (
        <>
            <Row>
                <Col>
                    <SmashStripe />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card bg="light" text="dark">
                        <Card.Body>
                            {(isLoading || !plan) && <SmashSpinner />}
                            {!isLoading && plan && <>
                                <p className="d-flex justify-content-between">Plan: <strong>{plan.planName}</strong></p>
                                <p className="d-flex justify-content-between">Price: <strong><SmashPrice price={plan.priceExclTax} currency={plan.currency} /></strong></p>
                                <p className="d-flex justify-content-between">VAT ({plan.percent}): <strong><SmashPrice price={plan.vat} currency={plan.currency} /></strong></p>
                                <p className="d-flex justify-content-between">Total: <strong><SmashPrice price={plan.priceInclTax} currency={plan.currency} /></strong></p>
                                <p className="d-flex justify-content-between">Autopay on: <strong>{plan.autoPayOn}</strong></p>
                            </>}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col className="d-flex justify-content-center my-4">
                    <p className="fs-7">This form is secured and encrypted</p>
                </Col>
            </Row>
        </>
    )
}

export default PlanSummary